module.exports = __webpack_public_path__ + "static/media/Honedge_gaussian2.23d425bd.png";